export default {
  hero_label: 'Recruit',
  hero_title: 'Careers',
  hero_subtitle: 'Join us in shaping Japan\'s future with AI.',
  jobs_title: 'Open Positions',
  process_title: 'Application Process',
  process_1_step: '01',
  process_1_title: 'Apply',
  process_1_desc: 'Submit via web form',
  process_2_step: '02',
  process_2_title: 'Document Screening',
  process_2_desc: 'Review of resume and work history',
  process_3_step: '03',
  process_3_title: 'Aptitude Test',
  process_3_desc: 'Online aptitude assessment',
  process_4_step: '04',
  process_4_title: 'Interview',
  process_4_desc: '1–2 rounds of interviews',
  process_5_step: '05',
  process_5_title: 'Offer',
  process_5_desc: 'Conditions meeting & start date coordination',
  benefits_title: 'Work Environment',
  benefit_1_title: 'AI Frontline Experience',
  benefit_1_desc: 'An environment to hone practical skills at the cutting edge of AI technology and business transformation',
  benefit_2_title: 'Work-Life Balance',
  benefit_2_desc: 'Flexible working through flextime and remote work options',
  benefit_3_title: 'Comprehensive Benefits',
  benefit_3_desc: 'Full social insurance, certification support, and learning assistance programs',
  benefit_4_title: 'AI Education Programs',
  benefit_4_desc: 'Full sponsorship for AI/DX-related in-house training, external seminars, and certifications',
  benefit_5_title: 'Global Opportunities',
  benefit_5_desc: 'Collaboration with leading AI companies domestically and internationally, and opportunities to join overseas projects',
  benefit_6_title: 'Merit-Based Evaluation',
  benefit_6_desc: 'Clear performance and expertise-based evaluation and compensation system',
  cta_title: 'Join us in shaping Japan\'s future with AI',
  cta_desc: 'We welcome applications from AI strategy, DX promotion, and talent development professionals.',
  cta_btn: 'Apply Now',
  modal_apply: 'Apply for This Position',
  modal_responsibilities: 'Responsibilities',
  modal_requirements: 'Requirements',
  modal_preferred: 'Preferred Qualifications',
  jobs: [
    {
      id: 1,
      title: 'AI Consultant',
      category: 'AIX Consulting',
      type: 'Full-time',
      location: 'Tokyo',
      description: 'Provide consistent consulting services from AI strategy development to DX promotion for client companies.',
      responsibilities: [
        'Hear and analyze client AI utilization challenges',
        'AI strategy and roadmap development and execution support',
        'Lead business transformation projects through AI implementation',
        'Proposals and presentations to stakeholders'
      ],
      requirements: [
        '3+ years of consulting experience',
        'Basic knowledge of AI and machine learning',
        'Logical problem-solving thinking',
        'Business-level Japanese proficiency'
      ],
      preferred: [
        'Experience in DX promotion projects',
        'Knowledge of data analysis and statistics',
        'MBA holder or equivalent experience'
      ]
    },
    {
      id: 2,
      title: 'DX Promotion Consultant',
      category: 'AIX Consulting',
      type: 'Full-time',
      location: 'Tokyo',
      description: 'Fuse digital technology and AI to transform entire business processes of enterprises.',
      responsibilities: [
        'DX current-state diagnosis and challenge extraction for client companies',
        'DX promotion strategy development and execution support',
        'Advisory for AI and data utilization platform implementation',
        'DX team organizational support and change management'
      ],
      requirements: [
        '3+ years of consulting experience in IT/digital domains',
        'Knowledge and experience in business process reform',
        'Project management capability',
        'Relationship-building skills with clients'
      ],
      preferred: [
        'Experience with enterprise systems such as Salesforce / SAP',
        'Experience in agile/scrum development',
        'Digital transformation-related certifications'
      ]
    },
    {
      id: 3,
      title: 'AI Talent Development Consultant',
      category: 'AIX Training',
      type: 'Full-time',
      location: 'Tokyo',
      description: 'Support building AI-ready organizations through designing and implementing AI literacy and talent development programs.',
      responsibilities: [
        'Planning, designing, and implementing AI talent development programs',
        'Facilitating AI literacy training for corporate clients',
        'Measuring learner progress and effectiveness with improvement proposals',
        'Curriculum content development'
      ],
      requirements: [
        '3+ years of experience in planning and implementing training programs',
        'Practical knowledge of AI and data science',
        'Excellent presentation and facilitation skills',
        'Ability to measure and analyze educational effectiveness'
      ],
      preferred: [
        'Experience in large-scale corporate talent development projects',
        'AI and data-related certifications',
        'Experience in e-learning content production'
      ]
    },
    {
      id: 4,
      title: 'AI Management Advisor',
      category: 'AIX Manager',
      type: 'Full-time',
      location: 'Tokyo',
      description: 'Lead advisory services for building AI promotion frameworks and organizational transformation from an AI management perspective.',
      responsibilities: [
        'AI promotion organization design and framework support',
        'Optimization of decision-making processes for AI utilization',
        'AI governance and risk management framework development',
        'AI strategy reporting and recommendations to management'
      ],
      requirements: [
        '5+ years of management experience',
        'Knowledge of organizational change and change management',
        'AI project lead experience',
        'Communication skills with management'
      ],
      preferred: [
        'Experience in large-scale AI promotion projects',
        'PMO and organizational consulting experience',
        'Knowledge of AI governance and ethics'
      ]
    }
  ]
};